import { render, staticRenderFns } from "./SettleDetails.vue?vue&type=template&id=3677e0ce&"
import script from "./SettleDetails.vue?vue&type=script&lang=js&"
export * from "./SettleDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports